// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"316":"c007ee841ee97da37269","675":"d1099ec53766a14b154c"}[chunkId] + ".js";
};